// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2pnKx","col":"styles_col__38G4v"};